<template>
  <div
    class="flex flex-col justify-center text-center gap-2 max-h-lg:gap-3 items-center pb-2 max-h-lg:pb-8 w-full"
    :class="[color, marginTop]">
    <div
      v-if="title"
      class="whitespace-pre-line font-anomaliaBold text-lg max-h-lg:!text-2xl">
      {{ title }}
    </div>
    <div
      v-if="subtitle"
      class="whitespace-pre-line leading-5 text-sm lg:text-md">
      {{ subtitle }}
    </div>
    <div
      v-if="text"
      class="whitespace-pre-line font-anomaliaBold text-lg xl:text-xl">
      {{ text }}
    </div>
    <div
      v-if="footer"
      class="whitespace-pre-line font-anomaliaBold text-lg lg:text-lg xl:text-2xl pt-3 max-h-md:pt-7"
      :class="colorFooter">
      {{ footer }}
    </div>
  </div>
</template>

<script setup lang="ts">
interface IProps {
  color?: string;
  marginTop?: string;
  title?: string;
  subtitle?: string;
  text?: string;
  footer?: string;
  colorFooter?: string;
}

withDefaults(defineProps<IProps>(), {
  title: '',
  text: '',
  subtitle: '',
  footer: '',
  color: 'text-dark',
  marginTop: 'mt-0',
  colorFooter: 'text-purple-800',
});
</script>
